// A block the learner opens and closes: a header that is the toggle (with its state announced and
// a chevron that turns) and the content under it. Closed content is not rendered.
import "./config";
import { useId } from "react";
import { View } from "tamagui";
import { Pressable } from "./controls";
import { Icon } from "./Icon";
import { Column, Fill } from "./layout";

export interface DisclosureProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** What the toggle row shows; it is the toggle's accessible name. */
  header: React.ReactNode;
  testId?: string | undefined;
  toggleTestId?: string | undefined;
  children: React.ReactNode;
}

export function Disclosure({
  open,
  onOpenChange,
  header,
  testId,
  toggleTestId,
  children,
}: DisclosureProps): React.JSX.Element {
  const panel = useId();
  return (
    <Column gap="2" data-testid={testId}>
      <Pressable
        flexDirection="row"
        justifyContent="flex-start"
        gap="2"
        width="100%"
        minHeight="var(--uiTarget)"
        aria-expanded={open}
        aria-controls={panel}
        data-testid={toggleTestId}
        onPress={() => {
          onOpenChange(!open);
        }}
      >
        <Fill>{header}</Fill>
        <View
          rotate={open ? "180deg" : "0deg"}
          transitionProperty="transform"
          transitionDuration="var(--durBase)"
        >
          <Icon name="chevron-down" size={14} />
        </View>
      </Pressable>
      {open ? <Column id={panel}>{children}</Column> : null}
    </Column>
  );
}
